const options = {
  paddingLeft: '0px',
};

export default { options };



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/News/style/style.js